import "@hotwired/turbo-rails"
import * as Turbo from "@hotwired/turbo"
import Modal from "bootstrap/js/dist/modal"
import "bootstrap/js/dist/collapse"
import "bootstrap/js/dist/dropdown"
import "./searchable_select"

Turbo.config.forms.confirm = (message, formElement, submitter) => {
  const el = submitter || formElement
  const isDestructive = el?.dataset?.turboMethod === "delete" || el?.getAttribute("method") === "delete"
  const btnClass = isDestructive ? "btn-danger" : "btn-primary"
  const btnLabel = isDestructive ? "Delete" : "Confirm"
  return new Promise((resolve) => {
    const dialog = document.createElement("div")
    dialog.innerHTML = `
      <div class="modal fade" tabindex="-1">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-body text-center py-4">
              <p class="fs-5 mb-0">${message}</p>
            </div>
            <div class="modal-footer justify-content-center border-0 pt-0">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
              <button type="button" class="btn ${btnClass} confirm-btn">${btnLabel}</button>
            </div>
          </div>
        </div>
      </div>`
    document.body.appendChild(dialog)
    const modalEl = dialog.querySelector(".modal")
    const modal = new Modal(modalEl)

    dialog.querySelector(".confirm-btn").addEventListener("click", () => {
      modal.hide()
      resolve(true)
    })
    modalEl.addEventListener("hidden.bs.modal", () => {
      dialog.remove()
      resolve(false)
    })

    modal.show()
  })
}
